import Localization from "@/Localization";
import LoginModal, { LoginData } from "Tems/Security/LoginModal";

export default class JqueryLoginModal implements LoginModal {
    private isVisible = false;
    private template = require('./JqueryLoginModal.html');
    private $el;

    public showError(text: string) {
        if (!this.$el) {
            throw "Cannot show Error because Modal is currently not open";
        }

        this.$el.find("#modalInsufficientUserLevelWarning").fadeIn()
            .find("#modalInsufficientUserLevelWarningText").text(text);
    }

    public requestLoginData(): Promise<LoginData> {
        if (!this.$el) {
            var $el = this.$el = $(this.template).appendTo("body");
            // Translations
            $el.find(".btn-primary").text(Localization.resourceStrings.LoginModal_ButtonSubmit);
            $el.find("#labelModalInsufficientUserLevel").text(Localization.resourceStrings.LoginModal_HeaderLogin);
            $el.find("#loginModalPasswordGroup label").prepend(document.createTextNode(Localization.resourceStrings.SetupUser_Password));
            $el.find("#loginModalUserNameGroup label").prepend(document.createTextNode(Localization.resourceStrings.SetupUser_UserName));

            $el.find("#defaultUserTitle").text(Localization.resourceStrings.LayoutView_DefaultUserTitle);
            $el.find("#defaultUserOperator")
                .text(Localization.resourceStrings.LayoutView_DefaultUserOperator)
                .click(() => $el.find("#loginModalUserName").val("Operator"));
            $el.find("#defaultUserAuthorizedClient")
                .text(Localization.resourceStrings.LayoutView_DefaultUserAuthorizedClient)
                .click(() => $el.find("#loginModalUserName").val("AuthorizedClient"));
            $el.find("#defaultUserService")
                .text(Localization.resourceStrings.LayoutView_DefaultUserService)
                .click(() => $el.find("#loginModalUserName").val("Service"));
        } else {
            this.$el.off();
        }

        return new Promise((resolve, reject) => {
            this.$el
                .on("submit", "form", (e) => {
                    var userName = e.target.userName.value;

                    if (userName) {
                        resolve({
                            userName: userName,
                            password: e.target["password"].value
                        });

                        this.$el.find("#modalInsufficientUserLevelWarning").hide();
                    }

                    return false;
                })
                .on("click", "#buttonModalCloseUserLevel", () => {
                    this.closeModal();
                    reject();
                });
        });
    }

    public closeModal() {
        this.$el.remove();
        this.$el = null;
    }
}